// EmployeeList.js
import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import { faUserPen } from "@fortawesome/free-solid-svg-icons";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import { viewerDisabledProps } from "../utils/permissions";

const TotalPresent = () => {
  const [employees, setEmployees] = useState([]);
  const [initialEmployees, setInitialEmployees] = useState([]);
  const [searchField, setSearchField] = useState("name");
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const navigate = useNavigate();

  useEffect(() => {
    axios
      .get(
        "https://ims-attendanceback.indevconsultancy.in/api/register-employee"
      )
      .then((response) => {
        if (response.data.status) {
          setEmployees(response.data.employees);
          setInitialEmployees(response.data.employees);
        }
      })
      .catch((error) => {
        console.error("Error fetching employee data:", error);
      });
  }, []);

  const handleEdit = (id) => {
    alert(`Edit employee with ID: ${id}`);
  };

  const handleDelete = (id) => {
    if (window.confirm("Are you sure you want to delete this employee?")) {
      const updated = employees.filter((emp) => emp.id !== id);
      setEmployees(updated);
      setInitialEmployees(updated);
    }
  };

  const handleSearch = () => {
    const filtered = initialEmployees.filter((emp) =>
      (emp[searchField] || "")
        .toString()
        .toLowerCase()
        .includes(searchTerm.toLowerCase())
    );
    setEmployees(filtered);
    setCurrentPage(1);
  };

  const handleReset = () => {
    setSearchTerm("");
    setEmployees(initialEmployees);
    setCurrentPage(1);
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = employees.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(employees.length / itemsPerPage);

  const changePage = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return "-";
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  return (
    <div className="px-3 py-3 bg-cream" style={{ minHeight: "100%" }}>
      <div className="card">
        <div className="card-header bg-skyBlue text-white">
          <h5 className="mb-0">Employee List</h5>
        </div>
        <div className="card-body">
          <div className="d-flex flex-md-row flex-column align-items-stretch gap-2 mb-3">
            <div className="flex-grow-1 flex-basis-0">
              <input
                type="text"
                className="form-control"
                placeholder="Enter Employee Name"
              />
            </div>

            <div className="flex-grow-1 flex-basis-0">
              <input
                type="text"
                className="form-control"
                placeholder="Enter Employee Code"
              />
            </div>

            <div className="flex-grow-1 flex-basis-0">
              <input
                type="number"
                className="form-control"
                placeholder="Enter Mobile no."
              />
            </div>

            <div className="flex-shrink-0">
              <button className="btn btn-primary w-100" onClick={handleSearch}>
                Search
              </button>
            </div>

            <div className="flex-shrink-0">
              <button className="btn btn-secondary w-100" onClick={handleReset}>
                Reset
              </button>
            </div>
          </div>

          <div className="d-flex justify-content-between align-items-center mb-3">
            <h6 className="mb-0">
              Total Employees: <strong>{employees.length}</strong>
            </h6>
            <button
              className="btn btn-primary bg-skyBlue"
              onClick={() => navigate("/employeeForm")}
              {...viewerDisabledProps()}
            >
              Add Employee
            </button>
          </div>

          <div className="table-responsive">
            <table className="table table-bordered table-striped text-center">
              <thead className="table-light">
                <tr>
                  <th>S.No.</th>
                  <th>Employee Code</th>
                  <th>Employee Name</th>
                  <th>Father Name</th>
                  <th>Mobile Number</th>
                  <th>Date of Joining</th>
                  <th>Date of Exit</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {currentItems.length === 0 ? (
                  <tr>
                    <td colSpan="7">No employees found.</td>
                  </tr>
                ) : (
                  currentItems.map((emp, index) => {
                    console.log(emp);
                    return (
                      <tr key={emp.id}>
                        <td>{indexOfFirstItem + index + 1}</td>
                        <td>{emp.employee_code}</td>
                        <td>{emp.emp_name}</td>
                        <td>{emp.father_name || "-"}</td>
                        <td>{emp.emp_mobile_no}</td>
                        <td>{formatDate(emp.date_of_joining)}</td>
                        <td>{formatDate(emp.date_of_exiting)}</td>

                        <td>
                          <button
                            className="btn btn-sm btn-warning me-1 bg-orange text-white"
                            onClick={() =>
                              navigate(`/editemploye/${emp.empdetailsid}`, {
                                state: { employee: emp },
                              })
                            }
                            {...viewerDisabledProps()}
                          >
                            <FontAwesomeIcon icon={faUserPen} />
                          </button>
                          <button
                            className="btn btn-sm me-1 btn-danger"
                            onClick={() => handleDelete(emp.id)}
                            {...viewerDisabledProps()}
                          >
                            <FontAwesomeIcon icon={faTrashAlt} />
                          </button>
                          <button
                            className="btn btn-sm btn-info text-white"
                            onClick={() =>
                              navigate("/employee-details", {
                                state: { employee: emp },
                              })
                            }
                          >
                            <FontAwesomeIcon icon={faEye} />
                          </button>
                        </td>
                      </tr>
                    );
                  })
                )}
              </tbody>
            </table>

            <nav
              className="mt-3 d-flex justify-content-center"
              aria-label="Pagination"
            >
              <ul className="pagination">
                <li
                  className={`page-item ${currentPage === 1 ? "disabled" : ""}`}
                >
                  <button
                    className="page-link"
                    onClick={() => changePage(currentPage - 1)}
                  >
                    Previous
                  </button>
                </li>
                {[...Array(totalPages)].map((_, i) => (
                  <li
                    key={i}
                    className={`page-item ${currentPage === i + 1 ? "active" : ""
                      }`}
                  >
                    <button
                      className="page-link"
                      onClick={() => changePage(i + 1)}
                    >
                      {i + 1}
                    </button>
                  </li>
                ))}
                <li
                  className={`page-item ${currentPage === totalPages ? "disabled" : ""
                    }`}
                >
                  <button
                    className="page-link"
                    onClick={() => changePage(currentPage + 1)}
                  >
                    Next
                  </button>
                </li>
              </ul>
            </nav>
          </div>
        </div>
        <div className="card-footer text-muted text-center small">
          Technology Partner: Indev Consultancy ©2025
        </div>
      </div>
    </div>
  );
};

export default TotalPresent;
